import React from 'react';

export default function CustomPagination({ page, totalPages, setPage }) {
  const handlePrev = () => setPage((p) => Math.max(p - 1, 0));
  const handleNext = () => setPage((p) => Math.min(p + 1, totalPages - 1));

  const baseBtn = 'px-3 py-1 text-sm rounded border transition-all';
  const activeNavBtn = 'text-accent border-accent hover:bg-accent hover:text-white cursor-pointer';
  const disabledNavBtn = 'text-slate-400 border-slate-200 cursor-not-allowed';

  return (
    <div className="flex justify-between items-center px-4 py-4 bg-[#f3f8ff] rounded-b-lg">
      <p className="text-sm text-slate-400">
        {totalPages > 0
          ? `Showing Page ${page + 1} of ${totalPages}`
          : ''}
      </p>

      <div className="flex gap-1 items-center">
        {/* Prev Button */}
        <button
          onClick={handlePrev}
          disabled={page === 0 || totalPages === 0}
          className={`${baseBtn} ${
            page === 0 || totalPages === 0 ? disabledNavBtn : activeNavBtn
          }`}
        >
          Prev
        </button>

        {/* Page Number Buttons */}
        {totalPages > 0 &&
          Array.from({ length: totalPages }).map((_, index) => (
            <button
              key={index}
              onClick={() => setPage(index)}
              className={`px-3 py-1 text-sm border rounded ${
                index === page
                  ? 'bg-accent text-white'
                  : 'text-black bg-white hover:bg-slate-100'
              }`}
            >
              {index + 1}
            </button>
          ))}

        {/* Next Button */}
        <button
          onClick={handleNext}
          disabled={page === totalPages - 1 || totalPages === 0}
          className={`${baseBtn} ${
            page === totalPages - 1 || totalPages === 0 ? disabledNavBtn : activeNavBtn
          }`}
        >
          Next
        </button>
      </div>
    </div>
  );
}
